import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { boxSizingKeys, boxSizingMixin, fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin, marginKeys, marginMixin, paddingKeys, paddingMixin, sizeKeys, sizeMixin } from '../mixins/layout';
import { withOmitProps } from '../helpers/elements';
import { positionKeys, positionMixin } from '../mixins/position';
import { backgroundColorKeys, backgroundColorMixin } from '../mixins/color';
import { borderRadiusKeys, borderRadiusMixin } from '../mixins/border';
import { styleForBreakpoints } from '../helpers/media-style';
var Box = styled.div.withConfig(withOmitProps(['inline'].concat(boxSizingKeys, fullWidthKeys, fullHeightKeys, sizeKeys, marginKeys, paddingKeys, positionKeys, backgroundColorKeys, borderRadiusKeys)))(_templateObject(), function (_ref) {
  var _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline;
  return styleForBreakpoints(inline, function (inline) {
    return "display: " + (inline ? 'inline-block' : 'block') + ";";
  });
}, backgroundColorMixin, borderRadiusMixin, boxSizingMixin, fullWidthMixin, fullHeightMixin, sizeMixin, marginMixin, paddingMixin, positionMixin);
export default Box;